import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminEmailCampaignCenter = lazy(() => import("@/pages/admin/AdminEmailCampaignCenter"));

export const Route = createFileRoute("/admin/email-campaign-center")({
  component: AdminEmailCampaignCenter,
});
